import React from "react";
import { Link } from "react-router-dom";
import LangSwitcher from "../../langSwitcher";
import DropDown from "../dropDown";
import { useSelector } from "react-redux";
import { Slang, SlangObj } from "../../../helpers";

const Index = ({ transparent = false, sub = false }) => {
  const lang = Slang("dashboardNavbar");
  const lang2 = Slang("navbar");
  const isAuth = useSelector((state) => state.auth.isAuth);
  const objLang = Array.isArray(SlangObj("navbar.categlist"))
    ? SlangObj("navbar.categlist")
    : Object.values(SlangObj("navbar.categlist"));

  return (
    <header
      id="header"
      className={`navbar navbar-expand-lg navbar-floating navbar-end navbar-light bg-${transparent ? "transparent" : "tertiary"
        } container`}
    >
      <div className="container">
        <nav className="js-mega-menu navbar-nav-wrap">
          <Link className="navbar-brand" to="/" aria-label="Front">
            <img
              className="navbar-brand-logo"
              src={`${sub
                  ? "../assets/img/logos/155x47/PNG/Groupe6.png"
                  : "./assets/img/logos/155x47/PNG/Groupe6.png"
                }`}
              alt="Logo"
            />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-default">
              <i className="bi-list"></i>
            </span>
            <span className="navbar-toggler-toggled">
              <i className="bi-x"></i>
            </span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link link-primary" to="/">
                  {lang2("t1")}
                </Link>
              </li>

              <li className="hs-has-mega-menu nav-item">
                <a
                  id="landingsMegaMenu"
                  className="hs-mega-menu-invoker nav-link link-primary dropdown-toggle"
                  aria-current="page"
                  href="#/"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {lang2("t2")}
                </a>

                <div
                  className="hs-mega-menu dropdown-menu w-100"
                  aria-labelledby="landingsMegaMenu"
                  style={{ minWidth: "30rem" }}
                >
                  <div className="row">
                    {!isAuth && (
                      <div className="col-lg-3 d-none d-lg-block">
                        <div
                          className="navbar-dropdown-menu-banner"
                          style={{
                            backgroundImage: `url(${sub ? ".." : "."
                              }/assets/img/svg/components/shape-3.svg)`,
                          }}
                        >
                          <div className="navbar-dropdown-menu-banner-content">
                            <div className="mb-4 text-primary">
                              <span className="h2 d-block">
                                {lang("info1")}
                              </span>
                              <p>{lang("info2")}</p>
                            </div>
                            <Link
                              className="btn btn-primary btn-transition"
                              to="/register"
                            >
                              {lang("info3")}
                              <i className="bi-chevron-right small"></i>
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className={isAuth ? "col" : "col-lg-9"}>
                      <div className="navbar-dropdown-menu-inner">
                        <div className="row">
                          <div className="col-sm mb-2 flex-list-categ">
                            {objLang.map((categ, index) => (
                              <Link
                                to={`/category/${btoa(categ.link)}`}
                                className="dropdown-item"
                                key={index}
                              >
                                <img
                                  src={`${sub ? ".." : "."
                                    }/assets/img/svg/icons/${categ.icon}`}
                                  width="24"
                                  height="24"
                                  alt={categ.name}
                                  className="me-2"
                                />
                                <span className="text-truncate">
                                  {categ.name}
                                </span>
                              </Link>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

              <li className="nav-item">
                <Link className="nav-link link-primary " to="/listing">
                  {lang2("t3")}
                </Link>
              </li>

              <li className="nav-item">
                <Link className="nav-link link-primary " to="/contact">
                  {lang2("t4")}
                </Link>
              </li>

              {/* <li className="nav-item">
                <Link className="nav-link link-primary" to="/dashboard">
                  {lang("t1")}
                </Link>
              </li> */}

              <li className="nav-item">
                <span className="nav-link">
                  <LangSwitcher icon />
                </span>
              </li>
              <li className="nav-item">
                <DropDown></DropDown>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Index;
